import React, {useEffect} from 'react'
import '../../styles/PlacmentTeam.css'
import { ShaliniSharma } from '../../assets'

const PlacmentTeam = () => {
    useEffect(() => {
        const revealElements = document.querySelectorAll(".scroll-reveal");
    
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("is-visible"); 
              } else {
                entry.target.classList.remove("is-visible"); 
              }
            });
          },
          { threshold: 0.8 } 
        );
    
        revealElements.forEach((element) => observer.observe(element));
    
        return () => {
          revealElements.forEach((element) => observer.unobserve(element));
        };
      }, []);
    
      return (
        <>
       
        <div className="placement-team-container">
          <div className="placement-header scroll-reveal">
            <h2 className="placement-heading">Placement Team</h2>
            <div className="placement-underline">
              <div className="placement-rectangle"></div>
            </div>
          </div>
          <p className="placement-intro scroll-reveal">
            <strong className="f_word">Placements</strong> give students the opportunity to gain skills specific to their subject or industry of choice as well as the employability skills required for real-life work. It also increases their knowledge of an industry or sector, allowing them to make better-informed decisions about future career choices. The Training & Placement department facilitates the process of placement of students passing out from the Institute besides collaborating with leading organizations in setting up internship and training programs for students. It enables them to get the right direction and training to fulfill their dreams. The inculcation of guidance about market patterns and employability helps the students in polishing their skills. Making a job available to every student according to his capabilities.
          </p>
          <p className="placement-description scroll-reveal">
            To ensure the preparedness of students well before they start facing recruiters, the dedicated Talent Management Team under the placement cell edifies students professionally. With the proper placement and training, students learn how to put forth their knowledge and abilities in the right way to fetch the best of jobs.
          </p>
          <h3 className="training-heading scroll-reveal">Training Activities:</h3>
          <ul className="training-list scroll-reveal">
            <li>Create awareness about “career planning” and “career mapping” among the students.</li>
            <li>
              Organize Various Training Programs to train the students in the areas of Quantitative Aptitude, Logical Reasoning, and Verbal reasoning through the in-house trainers.
            </li>
            <li>Equip the student with life skills.</li>
            <li>Train the students on “Personality development.”</li>
            <li>
              Train the students through Mock Interviews to perform well in the professional interviews as per the expectations of the corporate world.
            </li>
            <li>Train the students on group discussion techniques.</li>
            <li>Conduct online tests and written aptitude tests.</li>
          </ul>
          <div className="contact-card scroll-reveal" id="card">
            <div className="director_imgBx">
            <img

              src={ShaliniSharma}
              alt="Shalini Sharma"
              className="contact-image"
            />
            </div>
            <div className="contact-info-placment">
              <h4 className="contact-name">SHALINI SHARMA</h4>
              <p className="contact-position">Director - Placement & Corporate Relations</p>
              <p className="contact-company">Finxl Business School</p>
              <p className="contact-details">Mob: 9012345678</p>
              <p className="contact-details">Email: placement@finxl.in</p>
            </div>
          </div>
        </div>
       
        </>
  )
}

export default PlacmentTeam